// @flow strict
import * as React from 'react';
// eslint-disable-next-line css-modules/no-unused-class
import styles from '../style.scss';

/** @ignore */
const Ellipsis = () => <li className={styles.ellipsis}>&hellip;</li>;

export { Ellipsis };
